import { render, staticRenderFns } from "./PaymentsPerMonthChart.vue?vue&type=template&id=55f21214"
import script from "./PaymentsPerMonthChart.vue?vue&type=script&lang=js"
export * from "./PaymentsPerMonthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports